module.exports = __webpack_public_path__ + "img/CICADA-graphic-almost-black.624ad9c.svg";